
export const defaultRoad = [`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                                                         
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                                                        
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                                                       
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                                                      
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                                                     
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                                                    
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                                                   
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                                                  
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                                 
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                                
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                   .         .
                                               
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .
                                    .       .
                                              
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                     .     .  
                                             
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
------------------------------------------------------------------------------- 
                                            
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                       .                                 .
`,
`
-------------------------------------------------------------------------------
                                     .     .
                                    .       .
                                   .         .
                                  .           .
                                 .             .
                                .               .
                               .                 .
                              .                   .
                             .                     .
                            .                       .
                           .                         .
                          .                           .
                         .                             .
                        .                               .
                                                         
`
];